import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, PhoneCall, Zap, Settings, MessageSquare, ChevronDown } from 'lucide-react';
import { useRole, Role } from '../contexts/RoleContext';
export function Sidebar() {
  const {
    role,
    setRole
  } = useRole();
  const [roleMenuOpen, setRoleMenuOpen] = useState(false);
  const roleMenuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!roleMenuOpen) return;
    const onClick = (e: MouseEvent) => {
      if (roleMenuRef.current && !roleMenuRef.current.contains(e.target as Node)) {
        setRoleMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [roleMenuOpen]);
  const roleLabels: Record<Role, string> = {
    admin: 'System Admin',
    manager: 'Sales Manager',
    officer: 'Loan Officer'
  };
  const navItems = [{
    icon: <PhoneCall size={20} data-id="element-256" data-mp="37ffolyh7nk8c" />,
    label: 'Follow-up Queue',
    path: '/'
  }, {
    icon: <Zap size={20} data-id="element-257" data-mp="1lxu9zjj0csr7" />,
    label: 'Real-Time Leads',
    path: '/realtime'
  }, {
    icon: <MessageSquare size={20} data-id="element-258" data-mp="1qs8d683ww46f" />,
    label: 'Campaigns',
    path: '/campaigns'
  }];
  return <aside className="w-64 bg-slate-900 text-slate-300 flex flex-col h-screen border-r border-slate-800" data-id="element-259" data-mp="1h0kebm50zkux">
      <div className="h-16 flex items-center px-6 border-b border-slate-800" data-id="element-260" data-mp="24qep7y5sazcj">
        <div className="flex items-center gap-2 text-white font-bold text-xl" data-id="element-261" data-mp="24oc1jks3tiaz">
          <div className="w-8 h-8 bg-blue-600 rounded-md flex items-center justify-center" data-id="element-262" data-mp="29ogkdhghip4d">
            <Home size={18} className="text-white" data-id="element-263" data-mp="1voyoyj8oodm1" />
          </div>
          <span data-id="element-264" data-mp="20ns3mezpians">MortgageCRM</span>
        </div>
      </div>

      <div className="flex-1 py-6 overflow-y-auto" data-id="element-265" data-mp="20qedila2l296">
        <div className="px-4 mb-2 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-266" data-mp="k9a5w2yjvyqi">
          Menu
        </div>
        <nav className="space-y-1 px-3" data-id="element-267" data-mp="pappdql2xx6s">
          {navItems.map((item, i) => <NavLink key={i} to={item.path} className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors ${isActive ? 'bg-blue-600/10 text-blue-400 font-medium' : 'hover:bg-slate-800 hover:text-white'}`} data-id="element-268" data-mp="2qy2bkv5f82vv" data-mpi={i}>
              {item.icon}
              {item.label}
            </NavLink>)}
        </nav>
      </div>

      <div className="p-4 border-t border-slate-800" data-id="element-269" data-mp="285q27ogco1c8">
        <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-slate-800 hover:text-white transition-colors" data-id="element-270" data-mp="23881glchksfb">
          <Settings size={20} data-id="element-271" data-mp="1u8kznyfuhklq" />
          Settings
        </a>
        <div className="mt-4 relative" ref={roleMenuRef} data-id="element-272" data-mp="1uae6bdqgk4tq">
          <button onClick={() => setRoleMenuOpen(!roleMenuOpen)} className="w-full flex items-center justify-between px-3 py-2 rounded-md hover:bg-slate-800 transition-colors text-left" data-id="element-273" data-mp="3smwb4etozw9n">
            <div className="flex items-center gap-3" data-id="element-274" data-mp="1ae1pn1jicji0">
              <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-sm font-medium text-white uppercase" data-id="element-275" data-mp="1fd4lbvdllddb">
                {role.substring(0, 2)}
              </div>
              <div className="flex flex-col" data-id="element-276" data-mp="1o6hnzp1grtcl">
                <span className="text-sm font-medium text-white" data-id="element-277" data-mp="1o56jto43wjky">
                  {roleLabels[role]}
                </span>
                <span className="text-xs text-slate-500" data-id="element-278" data-mp="ri1x9pmmbdxw">View State</span>
              </div>
            </div>
            <ChevronDown size={16} className="text-slate-500" data-id="element-279" data-mp="10gdn3pfnu7pa" />
          </button>

          {roleMenuOpen && <div className="absolute bottom-full left-0 mb-2 w-full bg-slate-800 border border-slate-700 rounded-lg shadow-lg overflow-hidden z-20" data-id="element-280" data-mp="15fzxlr43t9ue">
              {(['admin', 'manager', 'officer'] as Role[]).map(r => <button key={r} onClick={() => {
            setRole(r);
            setRoleMenuOpen(false);
          }} className={`w-full text-left px-4 py-2 text-sm transition-colors ${role === r ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-700 hover:text-white'}`} data-id="element-281" data-mp="2gtltrw8dsbpf">
                  {roleLabels[r]}
                </button>)}
            </div>}
        </div>
      </div>
    </aside>;
}